<template>
  <div class="min-h-screen flex flex-col">
    <AppHeader />
    <main class="flex-grow">
      <slot />
    </main>
    <AppFooter />
    <CookieConsentBanner />
    <CookieSettingsModal />
  </div>
</template>

<script setup lang="ts">
useHead({
  titleTemplate: (titleChunk) => {
    return titleChunk ? `${titleChunk} - Enrico Reinsdorf` : 'Enrico Reinsdorf - Senior UX Designer'
  }
})
</script>
